import { BreakoutType } from "shared/types";

export function isBreakoutBasedOnPoll(breakout: BreakoutType | null, pollId: string | null) {
  return !!breakout?.grouping.startsWith(`poll:${pollId}-`);
}
